import { render, staticRenderFns } from "./locationGroups.vue?vue&type=template&id=01c61542&scoped=true&"
import script from "./locationGroups.vue?vue&type=script&lang=js&"
export * from "./locationGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c61542",
  null
  
)

export default component.exports